import { render, staticRenderFns } from "./TheMusicOfThePrimesArticle.vue?vue&type=template&id=ee52646c&"
import script from "./TheMusicOfThePrimesArticle.vue?vue&type=script&lang=js&"
export * from "./TheMusicOfThePrimesArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports